import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import API from '../../api';

export default function AddRemark() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [remarkText, setRemarkText] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!remarkText.trim()) {
      alert('Please enter a remark');
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      await API.post(`/customers/${id}/remarks`, 
        { text: remarkText },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert('Remark added successfully');
      navigate('/dashboard/followup-list');
    } catch (error) {
      console.error(error);
      alert('Failed to add remark');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto mt-10 p-6 bg-white rounded-xl shadow-md">
      <h2 className="text-2xl font-semibold mb-4 text-gray-800">
        Add Remark for Customer ID: <span className="text-blue-600">{id}</span>
      </h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="remark" className="block text-sm font-medium text-gray-700 mb-1">
            Remark
          </label>
          <textarea
            id="remark"
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-800"
            rows="4"
            value={remarkText}
            onChange={(e) => setRemarkText(e.target.value)}
            disabled={loading}
            required
          />
        </div>
        <button
          type="submit"
          disabled={loading}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg font-medium transition disabled:opacity-50"
        >
          {loading ? 'Adding...' : 'Add Remark'}
        </button>
      </form>
    </div>
  );
}
